/**
 * Objektklassifizierung schutzziele actions.
 * @module actions/objectklassifizierungSchutzziele/objectklassifizierungSchutzziele
 */

import { merge } from "lodash";

import { GET_OBJEKTKLASSIFIZIERUNG_SCHUTZZIELE } from "../../constants/ActionTypes";
import { parseParams } from "../../helpers/url/url";
import { parsePrependParams } from "../../helpers/Api/ParsePrependParams";

/**
 * Get objectklassifizierung schutzziele.
 * @function getObjektklassifizierungSchutzziele
 * @params {Number} id Id of the project.
 * @params {Number} bucket Bucket of the project.
 * @params {Object} filters Object with filters.
 * @returns {Object} Get objektklassifizierung schutzziele action.
 */
export function getObjektklassifizierungSchutzziele(
  id,
  bucket,
  filters,
  scales,
  units,
  typeDashboard
) {
  return {
    type: GET_OBJEKTKLASSIFIZIERUNG_SCHUTZZIELE,
    request: {
      op: "get",
      path: `objektklassifizierung-schutzziele/${id}`,
      params: merge(
        parseParams(filters),
        parsePrependParams(scales, "scale_"),
        parsePrependParams(units, "unit_"),
        bucket ? { bucket } : {},
        { typeDashboard: typeDashboard }
      )
    }
  };
}
